import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_COURSE_ENROLLMENTS_STATE } from "./consts";

import courseEnrollmentsReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_COURSE_ENROLLMENTS_STATE, builder => {
  builder.register(PATH_TO_COURSE_ENROLLMENTS_STATE, courseEnrollmentsReducer);
});

// using 'require' to make sure that analytics code executes AFTER reducer is registered
require("../analytics");

// reducer
export { courseEnrollmentsReducer, PATH_TO_COURSE_ENROLLMENTS_STATE };

// models
export { default as CourseEnrollment } from "./models/CourseEnrollment";

// selectors
export {
  isEnrolledInCourse,
  getNumberOfEnrolledCourses,
  getEnrolledCourseIds,
  getMostRecentlyEnrolledCourseId,
  getEnrolledCourses
} from "./selectors";
export {
  getFetchCourseEnrollmentsSuccess,
  getFetchCourseEnrollmentsStarted,
  getFetchCourseEnrollmentsError,
  getFetchCourseEnrollmentsFinished,
  courseEnrollmentsHaveFinishedFetching,
  courseEnrollmentIsDeleting,
  getCourseEnrollmentCreateSuccess,
  getCourseEnrollmentCreateError,
  courseEnrollmentCreateHasFinished,
  courseEnrollmentIsCreating,
  getCourseEnrollmentCreateErrorMessage
} from "./selectors/meta";

// actions
export {
  receiveCourseEnrollments,
  saveNewCourseEnrollment,
  deleteCourseEnrollment
} from "./actions";
export {
  fetchAllCourseEnrollmentsActionFactory,
  createCourseEnrollmentActionFactory,
  deleteCourseEnrollmentActionFactory
} from "./actions/meta";
